<template>
	<div>
		<div class="modal-content flex">
			<div class="text_left base_padding flex_1">
				<h4>{{ $t("CompanyDetailsModal.Legal") }}</h4>
				<md-field displayOnly>
					<label>{{ $t("common.vatId") }}</label>
					<md-input :value="detail.taxNum" disabled></md-input>
				</md-field>
				<md-field displayOnly v-if="detail.lei">
					<label>{{ $t("Completion.Company.LEI") }}</label>
					<md-input :value="detail.lei" disabled></md-input>
				</md-field>
				<md-field displayOnly v-if="detail.corporationTaxNo">
					<label>{{ $t("Completion.Company.TaxID") }}</label>
					<md-input :value="detail.corporationTaxNo" disabled></md-input>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("Completion.Company.Street") }}</label>
					<md-input :value="detail.street" disabled></md-input>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("common.postcode") }}</label>
					<md-input :value="detail.postcode" disabled></md-input>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("common.city") }}</label>
					<md-input :value="detail.city" disabled></md-input>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("common.country") }}</label>
					<md-input :value="formatCountry(detail.country)" disabled></md-input>
				</md-field>
			</div>
			<div class="text_left base_padding flex_1">
				<h4>{{ $t("CompanyDetailsModal.Details") }}</h4>
				<md-field displayOnly>
					<label style="top: -1rem !important">{{ $t("common.website") }}</label>
					<a class="md-input" disabled target="_blank" :href=sanitizeUrl(detail.website)>{{
							detail.website
						}}</a>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("investor.exchange.table.header.industry") }}</label>
					<md-input :value="detail.industry" disabled></md-input>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("CompanyDetailsModal.Industry.subcategory") }}</label>
					<md-input :value="detail.subIndustry" disabled></md-input>
				</md-field>
				<md-field
					displayOnly
					v-if="
            detail.cofaceDra > -1 &&
            enumDef.ratingStatus.isRatingStatusActive(detail.ratingStatus)
          "
				>
					<label>{{ $t("common.cofaceDra") }}</label>
					<md-input :value="detail.cofaceDra" disabled></md-input>
				</md-field>
			</div>
		</div>
		<div class="flex flex_end base_padding">
			<md-button class="md-blank" @click.stop="closeNoticeModal">{{
					$t("common.close")
				}}
			</md-button>
		</div>
	</div>
</template>
<script>
import {mapGetters} from "vuex";
import {companyApi} from "@/common/api/companyApi";
import {formatAsCountryName, formatAsIndustryText} from "@/common/format";
import {enumDef} from "@/common/enumDefs";

export default {
	data() {
		return {
			detail: {},
			enumDef: enumDef,
		};
	},
	created() {
		let { data } = this.noticeModalData;
		this.loadDetails(data.companyId || data.id);
	},
	methods: {
		formatCountry(value) {
			return formatAsCountryName(value);
		},
		closeNoticeModal() {
			this.$store.dispatch("setActionNoticModal", { show: false, data: {} });
		},
		loadDetails(companyId) {
			companyApi
				.CompanyInfo(companyId)
				.then((res) => {
					this.detail = {
						...res,
						industry: formatAsIndustryText(res.industry),
						subIndustry: formatAsIndustryText(res.subIndustry),
					};
				})
				.catch((e) => {
					this.toast(e);
				});
		},
		sanitizeUrl(url) {
			return url && url.startsWith("http") ? url : '//' + url;
		}
	},
	computed: {
		...mapGetters({
			noticeModalData: "noticeModalData",
			noticeModalShow: "noticeModalShow",
		}),
	},
};
</script>
